
import Vue from 'vue';
import { MessageBus } from '@/service/message-bus';
import { ToastMessagePanel } from '@/service/toastPanel';

export default Vue.extend({
  name: 'ShoppingCartProduct',
  mounted() {
    const toastPanelElement = document.getElementById('toast-panel');

    if (toastPanelElement !== null) {
      const toastMessagePanel = new ToastMessagePanel(toastPanelElement);

      // Listen for toast.created event on the messageBus.
      MessageBus.getInstance().subscribe('toast.created', (args: any[]) => {
        const message = args[0] ? args[0] : null;
        const isShoppingCart = args[1] ? args[1] : false;
        const extraMessage = args[2] ? args[2] : undefined;
        toastMessagePanel.showMessage(message, isShoppingCart, extraMessage);
      });
    }
  }
});
